export default {
  default: [
    {
      name: "financeReceivers.table",
      path: "/klanten",
      component: () => import("@/modules/financeReceivers/views/FinanceReceiversTableView.vue")
    },
    {
      path: "/klant/:id",
      name: "financeReceivers.view",
      component: () => import("@/modules/financeReceivers/views/FinanceReceiversDetailsView.vue"),
      redirect: { name: "financeReceivers.view.general" },
      children: [
        {
          path: "algemeen",
          name: "financeReceivers.view.general",
          component: () => import("@/modules/financeReceivers/views/tabs/GeneralView.vue")
        },
        {
          path: "faciliteit",
          name: "financeReceivers.view.facility",
          component: () => import("@/modules/financeReceivers/views/tabs/FacilityView.vue")
        }
      ]
    }
  ]
};
